const ERP_GLOBAL_FONT = `Microsoft YaHei`

document.fonts.load(`13px ${ERP_GLOBAL_FONT}`).then(function() {
  document.documentElement.style.setProperty('--erp-global-font', ERP_GLOBAL_FONT)
  window.__erp_global_font__ = ERP_GLOBAL_FONT
})



// WEBPACK FOOTER //
// ./src/layout/layout/setup/font-family.js